// Shared by the browser and the Node SSG. No browser globals here.
const site = require('./site.json');
const SITE_URL = (process.env.REACT_APP_SITE_URL || site.url).replace(/\/$/, '');
const plainText = value => String(value ?? '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
const description = value => plainText(value).slice(0, 160);
const categoryPath = name => name.trim().toUpperCase() === 'PROMOCIONES' ? '/promociones' : `/categorias/${encodeURIComponent(name.trim())}`;
const subcategoryPath = name => name.trim().toUpperCase() === 'PROMOCIONES' ? '/promociones' : `/subcategorias/${encodeURIComponent(name.trim())}`;
const pages = {
  '/': ['Familia Garcia Vidal | Del campo a tu mesa', 'Alimentos de calidad de Familia Garcia Vidal en Rosario. Conocé nuestros productos, locales y opciones de entrega.'],
  '/productos': ['Productos | Familia Garcia Vidal', 'Conocé el catálogo de alimentos de Familia Garcia Vidal, sus precios, presentaciones y disponibilidad.'],
  '/promociones': ['Promociones | Familia Garcia Vidal', 'Consultá las promociones disponibles de Familia Garcia Vidal y elegí tus productos.'],
  '/locales': ['Nuestros locales | Familia Garcia Vidal', 'Direcciones, horarios y datos de contacto de nuestros locales de 3 de Febrero y Sarmiento, en Rosario.'],
  '/contacto': ['Contacto | Familia Garcia Vidal', 'Contactá a Familia Garcia Vidal en Rosario. Consultas, atención por WhatsApp y correo electrónico.'],
  '/nosotros': ['Nosotros | Familia Garcia Vidal', 'Conocé nuestra historia de tradición, campo y familia y el proceso productivo de Familia Garcia Vidal.'],
  '/envios': ['Envíos | Familia Garcia Vidal', 'Consultá tu zona y horario de entrega de Familia Garcia Vidal antes de realizar tu compra.'],
  '/credo': ['Nuestro credo | Familia Garcia Vidal', 'Los valores de Familia Garcia Vidal: unión familiar, trabajo, respeto por la naturaleza y diversidad.'],
  '/familia': ['Cliente fiel | Familia Garcia Vidal', 'Formá parte de la familia Garcia Vidal. Conocé el programa de cliente fiel y registrate.'],
};
const imagesFor = (product, apiUrl = '') => {
  const values = [...(product.imagenes || []), product.UrlImagen, product.UrlImagen2, product.UrlImagen3];
  return [...new Set(values.flatMap(value => String(value || '').split(',')).map(value => value.trim()).filter(Boolean))].slice(0, 3).map(value => {
    const drive = /(?:drive|docs)\.google\.com/.test(value) && (value.match(/\/d\/([\w-]+)/) || value.match(/[?&]id=([\w-]+)/));
    if (drive) return `https://lh3.googleusercontent.com/d/${drive[1]}`;
    try { const url = new URL(value, `${apiUrl || SITE_URL}/`); return /^https?:$/.test(url.protocol) ? url.href : ''; } catch { return ''; }
  }).filter(Boolean);
};
const productMetadata = (product, siteUrl = SITE_URL, apiUrl = '') => {
  const canonical = `${siteUrl}/producto/${product.idProductos}`;
  const images = imagesFor(product, apiUrl);
  const text = description(product.seo_descripcion || product.descripcion || product.NombresProductos);
  const price = product.Precio === null || product.Precio === undefined || product.Precio === '' ? NaN : Number(product.Precio);
  const stock = product.sin_stock_web;
  const availability = stock === true || stock === 1 ? 'OutOfStock' : stock === false || stock === 0 ? 'InStock' : undefined;
  return {
    title: `${product.NombresProductos} | ${site.name}`, description: text, canonical,
    image: images[0] || `${siteUrl}/logo.png`, robots: 'index,follow',
    structuredData: {
      '@context': 'https://schema.org', '@type': 'Product', name: product.NombresProductos,
      description: plainText(product.seo_descripcion || product.descripcion || product.NombresProductos),
      url: canonical, image: images.length ? images : undefined,
      brand: product.marca ? { '@type': 'Brand', name: product.marca } : undefined,
      category: product.nombre_categoria || undefined,
      offers: Number.isFinite(price) && price >= 0 ? {
        '@type': 'Offer', priceCurrency: 'ARS', price, url: canonical,
        availability: availability ? `https://schema.org/${availability}` : undefined,
      } : undefined,
    },
  };
};
const routeMetadata = (pathname, search = '', siteUrl = SITE_URL) => {
  const params = new URLSearchParams(search);
  let route = pathname.replace(/\/$/, '') || '/';
  if (route === '/sucursales') route = '/locales';
  let label = '';
  if (route === '/productos' && !params.has('search')) {
    if (params.get('sub')) route = subcategoryPath(params.get('sub'));
    else if (params.get('cat')) route = categoryPath(params.get('cat'));
  }
  if (/^\/(subcategorias|categorias)\//.test(route)) {
    try { label = decodeURIComponent(route.split('/').slice(2).join('/')); } catch { label = ''; }
    route = route.startsWith('/subcategorias/') ? subcategoryPath(label) : categoryPath(label);
    if (route === '/promociones') label = '';
  }
  const known = !!pages[route] || !!label;
  const title = label ? `${label} | ${site.name}` : (pages[route]?.[0] || `Página no indexable | ${site.name}`);
  const text = label ? `Conocé los productos de ${label} en Familia Garcia Vidal. Consultá precios, presentaciones y disponibilidad.` : (pages[route]?.[1] || 'Familia Garcia Vidal.');
  const noindex = !known || params.has('search') || Number(params.get('page') || 1) > 1;
  return {
    title, description: description(text), canonical: `${siteUrl}${route === '/' ? '/' : route}`,
    robots: noindex ? 'noindex,follow' : 'index,follow', image: `${siteUrl}/logo.png`,
    structuredData: known ? { '@context': 'https://schema.org', '@type': label || route === '/productos' || route === '/promociones' ? 'CollectionPage' : 'WebPage', name: title, url: `${siteUrl}${route}` } : undefined,
  };
};
module.exports = { SITE_URL, pages, plainText, categoryPath, subcategoryPath, imagesFor, productMetadata, routeMetadata };
